import { sendCtmEvtLog, errorLog } from '@/utils/log'

import wx from '@/utils/wx'


export default {
    install (_Vue) {
        _Vue.prototype.$sendCtmEvtLog = sendCtmEvtLog
        _Vue.prototype.$showCallModal = function (success, event_name, tip_content = '') {
            success()
        }
        _Vue.prototype.$errorLog = errorLog
        _Vue.prototype.$wx = wx

    }
}
